import { Component } from '@angular/core';

@Component({
	selector: 'clearcals-webstories',
	template: `<div><mat-spinner></mat-spinner></div>`,
	styleUrls: ['./web-stories-loading.component.css'],
})
export class WebStoriesLoadingComponent {}
